import React,{useEffect, useRef} from 'react'
import { useState } from 'react'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';
import { Print } from '@mui/icons-material';
import ledgerEntryServices from '../ledgerEntryServices';
import { Link } from 'react-router-dom';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';
import MonthlyDateSelect from '../../../../../../components/AppInput/MonthlyDateSelect';


const CellActions = (props) =>{
    return(
        <>
            


            {(props.data.voucherType === "Sale" || props.data.voucherType === "Purchase") &&
                  <Link to={`/voucher/sale-purchase/details/${props.data.voucherId}`}>Voucher Details</Link>
              }
              {(props.data.voucherType === "Payment" || props.data.voucherType === "Receipt") &&
                  <Link to={`/voucher/payment-receipt/details/${props.data.voucherId}`}>Voucher Details</Link>
              }
              {(props.data.voucherType === "Contra" || props.data.voucherType === "Journal") &&
                  <Link to={`/voucher/contra-journal/details/${props.data.voucherId}`}>Voucher Details</Link>
              }
              {(props.data.voucherType === "CreditNote" || props.data.voucherType === "DebitNote") &&
                  <Link to={`/voucher/contra-journal/details/${props.data.voucherId}`}>Voucher Details</Link>
              }
              {(props.data.voucherType === "Expense" ) &&
                  <Link to={`/voucher/expense/details/${props.data.voucherId}`}>Voucher Details</Link>
              }

              {(props.data.voucherType === "ChallanIn" || props.data.voucherType === "ChallanOut") &&
                  <Link to={`/voucher/challan/details/${props.data.voucherId}`}>Voucher Details</Link>
              }
              
            {/*

            <ProjectForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            */}
        </>
    )
}


function LedgerEntryPage() {

  const [ledgerEntryList,setLedgerEntryList] = useState(null);
  const {ledgerDD,getDDDataById} = useAppData();
  const [filter,setFilter] = useState(null);

  const getLedgerEntryList = () =>[
    ledgerEntryServices.getList(filter).then(res=>{
      setLedgerEntryList(res.data);
    }).catch(error=>{

    }).finally(()=>{

    })
  ]

  
  const gridRef = useRef();

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"ledgerId",headerName: "ledger Name" , width:300, valueGetter: params => getDDDataById(ledgerDD,params.data.ledgerId).label},
        //{field:"voucherId",headerName: "voucherId"},

        {headerName:"Voucher", width:"250", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
        }, 
        {field:"voucherType",headerName: "V.Type"},
        {field:"debit",headerName: "debit"},
        {field:"credit",headerName: "credit"},
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);

  useEffect(()=>{
      getLedgerEntryList();
  },[filter])
  return (
    <FinanceLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Ledgers Entries</h4></div>
        <div className='col-md-6'>
          <MonthlyDateSelect filter={filter} setFilter={setFilter} />  
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 650}}>
              <AgGridReact
                ref={gridRef}
                rowData={ledgerEntryList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getLedgerEntryList}
              />
            </div>
          </div>
        </div>
    </FinanceLayout>
    
  )
}

export default LedgerEntryPage